import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ResetSentComponent } from '../../lib/reset-sent/reset-sent.component'

@Component({
  selector: 'ftr-reset-sent-page',
  template: '<ftr-reset-sent />',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResetSentComponent],
})
export class ResetSentPage {}
